(function (backoffice, $) {
    /* Set change event handlers for dossier item types */
    backoffice.InitDossierItemTypeChangeHandlers = function (clientKey, profitEnvironmentKey) {
        $(document).on("change", "[data-dossier-item-type], [data-checklist-dossier-item-type], [data-bank-account-dossier-item-type], [data-wage-component-dossier-item-type]", function (evt) {
            $.ajax({
                url: "/ProfitEnvironment/DossierItemMarks",
                cache: false,
                data: {
                    clientKey: clientKey,
                    profitEnvironmentKey: profitEnvironmentKey,
                    dossierItemTypeId: $(evt.target).val()
                },

                success: function (list) {
                    var id = $(evt.target).attr('id');
                    if (id.includes("Type")) {
                        var selector = "[id='" + id.replace('Type', 'Mark') + "'";
                        $(selector).empty().append($("<option />", { value: "", text: "Geen kenmerk" }));
                        if (list) {
                            $.each(list,
                                function () {
                                    $(selector).append($("<option />", { value: this.id, text: this.description }));
                                });
                        }
                    }
                }
            });
        });
    }

    /* Initialize corporate color */
    backoffice.InitCorporateColor = function () {
        $("#input-color-1").change(function () {
            $("#span-color-1").css("color", this.value);
            $("#span-color-1").css("background-color", this.value);
        });
        $("#input-color-1").change();
        $("#input-color-2").change(function () {
            $("#span-color-2").css("color", this.value);
            $("#span-color-2").css("background-color", this.value);
        });
        $("#input-color-2").change();
    }

    backoffice.InitTableDragAndDrop = function () {
        $("[data-toggle='tooltip']").tooltip();

        $("[data-tableDnD]").tableDnD({
            onDragClass: "dragShadow",
            onDrop: function (table, row) {
                $(row).attr('data-rowaltered', 'true');
            }
        });
    }

}(window.backoffice = window.backoffice || {}, $));
